<template>
	<v-dialog v-model="dialog" width="720">
		<v-card>
			<v-card-title primary-title class="headline">
				Generowanie pism seryjnych
			</v-card-title>

			<v-card-text>
				<div>
					Wybrany szablon: <strong>{{ template.fileName }}</strong><br/>
					Czy na pewno chcesz wygenerować pisma? Upewnij się, że adresaci zostali wybrani poprawnie.
				</div>
				<div class="container">
					<div class="column">
						<strong>Status oferty</strong>
						<template v-if="allStatusSelected">
							<ul class="mt-2">
								<li>Wszystkie</li>
							</ul>
						</template>
						<template v-else>
							<ul class="mt-2">
								<template v-for="(item, i) in statusList">
									<li v-if="status[item.value.toLowerCase() + '_chx']" :key="'status-' + i">
										{{ item.name }}
									</li>
								</template>
							</ul>
						</template>
					</div>
					<div class="column">
						<strong>Atrybuty projektu</strong>
						<template v-if="allAttributesSelected">
							<ul class="mt-2">
								<li>Wszystkie</li>
							</ul>
						</template>
						<template v-else>
							<ul class="mt-2">
								<template v-for="(item, i) in attributeList">
									<li v-if="attributes[item.value]" :key="'attribute-' + i">
										{{ item.name }}
									</li>
								</template>
							</ul>
						</template>
					</div>
				</div>

				<v-layout row>
					<v-alert :value="true" outline type="info">
						Uwaga! W przypadku gdy pismo jest generowane na podstawie oferty, znaczniki dot. projektów
						zostaną usunięte z szablonu.
					</v-alert>
				</v-layout>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" @click="generateWritings">
					Generuj
				</v-btn>
				<v-btn color="blue" @click="dialog = false">
					Anuluj
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import {Files} from "@/utils/Files";

	export default {
		name: "ContestSerialWritingsDialog",

		mixins: [Files],

		watch: {
			value: {
				handler (value) {
					this.dialog = value;
				}
			},
			dialog: {
				handler (value) {
					if (!value) this.$emit("close-dialog");
				}
			}
		},

		methods: {
			async generateWritings () {
				let requestData = {
					contestId: this.$route.params.id,
					templateId: this.template.id,
					offerStatusList: Object.keys(this.status).filter(key => key !== 'all' && this.status[key])
						.map(status => status.replace('_chx', '').toUpperCase()),
					isHidden: this.attributes.isHidden,
					isNotHidden: this.attributes.isNotHidden,
					isArchived: this.attributes.isArchived,
					isNotArchived: this.attributes.isNotArchived,
					isAwaitingAnnexSigning: this.attributes.isAwaitingAnnexSigning,
					isNotAwaitingAnnexSigning: this.attributes.isNotAwaitingAnnexSigning
				};
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getSerialWritingsFileUrl(
						requestData
					),
					"korespondencja.zip"
				);
				this.dialog = false;
			}
		},

		computed: {
			allStatusSelected () {
				return Object.keys(this.status).every(key => key === 'all' || this.status[key]);
			},

			allAttributesSelected () {
				return Object.keys(this.attributes).every(key => key === 'all' || this.attributes[key]);
			}
		},

		data () {
			return {
				dialog: false
			};
		},

		props: {
			value: {type: Boolean, required: true},
			template: {required: true},
			status: {type: Object, required: true},
			statusList: {type: Array, required: true},
			attributes: {type: Object, required: true},
			attributeList: {type: Array, required: true}
		}
	};
</script>

<style scoped>
	.container {
		display: flex;
	}

	.column {
		flex: 50%;
	}

	ul {
		list-style: none;
	}

	ul li:before {
		content: '✓';
		padding-right: 7px;
	}
</style>